import { render, staticRenderFns } from "./PrescriptionCertDialog.vue?vue&type=template&id=3258f554&scoped=true&"
import script from "./PrescriptionCertDialog.vue?vue&type=script&lang=js&"
export * from "./PrescriptionCertDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionCertDialog.vue?vue&type=style&index=0&id=3258f554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3258f554",
  null
  
)

export default component.exports